<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';
	import metaImage from './images/SMS-FS-calendar.jpg';

	let { data, children } = $props();
	const { person, reviews, title } = $derived(data);
</script>

{@render children?.()}
<Section backgroundColor="blue">
	<h1>{title}</h1>
	<p class="font-bold text-balance">
		{#if person.bio}
			{person.bio}
		{:else}
			I specialize in helping people figure out the best solutions for their
			windows. Please book a call with me by picking a time slot on my calendar.
			Let’s get started on making your windows just right!
		{/if}
	</p>
</Section>

{#if person.calendar.domain}
	<Section
		backgroundColor="grey"
		class="
    min-h-120
    max-md:py-0
  "
	>
		<div
			class="
     col-span-full! w-full
     max-md:-mb-5
   "
		>
			<script
				src="https://embed.ycb.me"
				async="true"
				data-autoscroll
				data-domain={person.calendar.domain}
			></script>
		</div>
	</Section>
{/if}

<Section backgroundColor="blue">
	<div
		class="
    flex h-full flex-col gap-5
    md:flex-row
    md:[&_p]:place-self-start
  "
	>
		<div>
			{#if person.image}
				<Image
					noMeta
					src={person.image}
					alt={`${person.firstName}`}
					class="
       aspect-square max-w-sm rounded-full border-4 border-solid
       border-indow-white
     "
				/>
			{/if}
		</div>

		<div
			class="
     max-w-prose border-solid border-indow-white
     max-md:border-t-2 max-md:pt-5
     md:border-l-2 md:pl-4
   "
		>
			{#if person.title}
				<p class="mb-1 text-left font-bold text-indow-grey-dark">Title</p>
				<p class="pl-4 text-left">
					{person.title}
				</p>
			{/if}
			{#if person.hometown}
				<p class="mb-1 text-left font-bold text-indow-grey-dark">Hometown</p>
				<p class="pl-4 text-left">
					{person.hometown}
				</p>
			{/if}
			{#if person.hobbies}
				<p class="mb-1 text-left font-bold text-indow-grey-dark">Hobbies</p>
				<p class="pl-4 text-left">
					{person.hobbies}
				</p>
			{/if}
			{#if person.questions}
				{#each person.questions as { question, answer }, i (i)}
					{#if question}
						<p class="mb-1 text-left font-bold text-indow-grey-dark">
							{question}
						</p>
					{/if}
					{#if answer}
						<p class="pl-4 text-left">{answer}</p>
					{/if}
				{/each}
			{/if}
			{#if person.contact}
				<div>
					{#if person?.contact.phone}
						<p class="md:text-left">
							<strong>Phone:</strong>
							<a href={'tel:' + person?.contact.phone}
								>{person?.contact.phone}</a
							>
						</p>
					{/if}
					{#if person?.contact.email}
						<p class="md:text-left">
							<strong>Email:</strong>
							<a href={'mailto:' + person?.contact.email}
								>{person?.contact.email}</a
							>
						</p>
					{/if}
				</div>
			{/if}
		</div>
	</div>
</Section>
<Reviews {reviews} />
<svelte:head>
	{#if metaImage.img}
		<meta property="og:image" content={metaImage.img?.src} />
		<meta property="og:image:alt" content="Book An Appointment" />
		<meta property="og:image:width" content={metaImage.img?.w} />
		<meta property="og:image:height" content={metaImage.img?.h} />
		<meta property="twitter:image" content={metaImage.img?.src} />
		<meta property="twitter:image:alt" content="Book An Appointment" />
	{/if}
</svelte:head>
